import { useContext, useEffect } from "react";
import { ActivityFeedContext } from "@/context/ActivityFeedContext";


const useShowNewNotifications = () => {
    const {newNotificationIds, setNewNotificationIds} =  useContext(ActivityFeedContext);

    function observerCallback(entries:any[], observer:any) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
              setTimeout(() => {
                removeElementFromNewActivites()
              }, 3000)
              
            }
        });
    };

    useEffect(() => {
        if(newNotificationIds){
            const observer = new IntersectionObserver(observerCallback, {
                threshold: 0
            });
            
           
            
            for (const id of newNotificationIds) {
                const element = document.querySelector(`#${id}`)
                if(element) {
                    observer.observe(element)
                }
            }
        }
        

        
    }, [newNotificationIds])

    function isNewElement(id:string) {
        return newNotificationIds.includes(id);
    }

    function removeElementFromNewActivites() {
        setNewNotificationIds([])
    }

    return {
        isNewElement
    }
}

export default useShowNewNotifications